var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.98,
    height: 6.9,
    viewBox: "0 0 11.98 6.9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.28 6.6a1 1 0 001.4 0l4.3-4.3 4.3 4.3a1 1 0 001.4-1.4L6.78.3a1.09 1.09 0 00-.7-.3.91.91 0 00-.7.3L.48 5.2a.86.86 0 00-.2 1.4z"
  })));
}
export default SvgIconChevronUp;